import { render, staticRenderFns } from "./left-area.vue?vue&type=template&id=3855bdea&scoped=true&"
import script from "./left-area.vue?vue&type=script&lang=js&"
export * from "./left-area.vue?vue&type=script&lang=js&"
import style0 from "./left-area.vue?vue&type=style&index=0&id=3855bdea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3855bdea",
  null
  
)

export default component.exports